import { render, staticRenderFns } from "./NavbarDropdown.vue?vue&type=template&id=1b397a2f"
import script from "./NavbarDropdown.vue?vue&type=script&lang=js"
export * from "./NavbarDropdown.vue?vue&type=script&lang=js"
import style0 from "./NavbarDropdown.vue?vue&type=style&index=0&id=1b397a2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports